import { getRequest } from './api';

const BASE = '/api/delivery-teams';

export async function getWfmLanding(month) {
  return getRequest('manager', `${BASE}/landing`, { month });
}

export async function getWfmNode(nodeId, month) {
  return getRequest('manager', `${BASE}/nodes/${encodeURIComponent(nodeId)}`, { month });
}

export async function getWfmTeam(teamId, month) {
  return getRequest('manager', `${BASE}/teams/${encodeURIComponent(teamId)}`, { month });
}

export async function getWfmTeamMembers(teamId, month) {
  return getRequest('manager', `${BASE}/teams/${encodeURIComponent(teamId)}/members`, { month });
}

export async function getWfmTrend(nodeId) {
  return getRequest('manager', `${BASE}/trend`, nodeId ? { node_id: nodeId } : {});
}

export async function getWfmAccess() {
  return getRequest('manager', `${BASE}/access`);
}

export async function getWfmPopulationAll({ level, month, signal }) {
  return getRequest('manager', `${BASE}/population/all`, month ? { level, month } : { level }, { signal });
}
